import React, { createContext, useState } from "react";

const LoaderContext = createContext<any>({});

export const LoaderProvider = ({ children }: any) => {
  const [isLoading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState<string | null>(null);
  return (
    <LoaderContext.Provider
      value={{ isLoading, setLoading, loadingMessage, setLoadingMessage }}
    >
      {children}
    </LoaderContext.Provider>
  );
};

export default LoaderContext;
